<template>
  <div id="app">
    <img class="gwent-logo" :src="require(`@/assets/gwent.png`)" />
    <HelloWorld />
  </div>
</template>

<script>
import HelloWorld from "./components/HelloWorld";

export default {
  name: "App",
  components: {
    HelloWorld
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.gwent-logo {
  max-height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue